const initialState = {
  userDeregistered: ''
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_DEREGISTERED':
      return { ...state, userDeregistered: action.payload };
    default:
      return state;
  }
};

export default UserReducer;
